import { createSlice } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
import { API } from 'api';

const initialState = {};

export const vendorSlice = createSlice({
	name: 'vendorState',
	initialState,
	reducers: {},
});

export const getVendorList =
	({ search_type = '', filter_by = {} }) =>
	async () => {
		console.log('search_type 1', search_type);
		console.log('filter_by 1', filter_by);

		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				filter_by: {
					...filter_by,
				},
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.count,
		}));
	};

export const addVendor =
	({ req_data, setErrors }) =>
	async () => {
		console.log(req_data);
		const url = '/create';

		const data = {
			create_type: 'vendor',
			data: {
				password: req_data?.password,
				vendor_info: req_data?.vendor_info,
				vendor_type: req_data?.vendor_type,
			},
		};

		const CREDENTIALS = {
			url,
			data,
			setErrors,
		};

		return API.common(CREDENTIALS).then((res) => {
			toaster.success('Vendor added successfully');
			return res;
		});
	};

// export const updateVendorSection =
// 	({ req_data, setErrors }) =>
// 	async () => {
// 		const CREDENTIALS = {
// 			url: '/update',
// 			data: req_data,
// 			setErrors,
// 		};

// 		console.log(CREDENTIALS);
// 		return API.common(CREDENTIALS).then((res) => res);
// 	};

export const updateInfoVendor =
	({ req_data, setErrors }) =>
	async () => {
		console.log(req_data);
		let data = {};
		data = {
			update_type: 'vendor',
			id: req_data?.ids?.id,
			data: {
				vendor_type: req_data?.vendor_type,
				id: req_data?.ids?.id,
				vendor_info: req_data?.vendor_info,
			},
		};
		console.log(data);
		const CREDENTIALS = {
			url: '/update',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);
		return API.common(CREDENTIALS).then((res) => res);
	};

export const updateVendorSection =
	({ req_data, setErrors }) =>
	async () => {
		console.log(req_data);
		let data = {};
		data = {
			update_type: 'vendor',
			id: req_data?.id,
			data: {
				...req_data,
			},
		};
		console.log(data);
		const CREDENTIALS = {
			url: '/update',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);
		return API.common(CREDENTIALS).then((res) => res);
	};

export const updateVendor =
	({ req_data, setErrors }) =>
	async () => {
		console.log(req_data);
		let data = {};
		data = {
			update_type: 'vendor',
			id: req_data?.data?.id,
			data: {
				...req_data,
			},
		};
		console.log(data);
		const CREDENTIALS = {
			url: '/update',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);
		return API.common(CREDENTIALS).then((res) => res);
	};

export default vendorSlice.reducer;
